/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable multiline-ternary */
import { useToast, Flex, Avatar, FormLabel, Text } from '@chakra-ui/react'
import { useState, useEffect } from 'react'
import { FaBriefcase, FaEye, FaSave } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { FindUser } from '../../../../../components/FindBox'
import { InputCmp } from '../../../../../components/InputCmp'
import LoadingContainer from '../../../../../components/LoadingContainer'
import { ModalBase } from '../../../../../components/ModalBase'
import { SelectCmp } from '../../../../../components/SelectCmp'
import { DescricaoCargo, iColaboradorSalario } from '../../../../../interfaces'
import { appApi } from '../../../../../services/appApi'
import { PropInvalida } from '../../../../../Utils/Helper'
import { DashedBox } from './styles'

export interface iColaboradorSalarioInput {
  id: string
  cargoESalarioId: string
  nivel: string
  salario: number
}

interface iProps {
  isOpen: boolean
  onRequestClose: () => void
  onUpdateEmployee: (upEmployee: iColaboradorSalarioInput) => void
  colaborador: iColaboradorSalario
}

export const UpdateColaboradorModal: React.FC<iProps> = ({
  isOpen,
  onRequestClose,
  onUpdateEmployee,
  colaborador
}) => {
  const toast = useToast()
  const nav = useNavigate()
  const [IsLoading, setIsLoading] = useState(false)
  const [CargoESalarioIsInvalid, setCargoESalarioIsInvalid] = useState(false)
  const [CargosESalarios, setCargosESalarios] = useState<DescricaoCargo[]>([])
  const [Model, setModel] = useState<iColaboradorSalario>({
    dataIngresso: '',
    id: '',
    nome: ''
  })

  function SelecionarCargoESalario(id: string): void {
    setModel({ ...Model, cargoESalarioId: id, nivel: '' })
    setCargoESalarioIsInvalid(false)
  }

  function GetDescritivos(): void {
    setIsLoading(true)

    appApi.get('api/CargosESalarios')
      .then((res) => {
        setCargosESalarios(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function InternalOnUpdate(): void {
    onUpdateEmployee({
      cargoESalarioId: Model.cargoESalarioId ?? '',
      nivel: Model.nivel ?? '',
      salario: Model.salario ?? 0,
      id: Model.id
    })
  }

  useEffect(() => {
    GetDescritivos()
  }, [])

  useEffect(() => {
    setModel(colaborador)
  }, [colaborador])

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onRequestClose}
      className='react-modal-content-styled-scroll'
      Titulo={'Atualizar colaborador'}
      styleHeader={{ alignItems: 'center', paddingLeft: '1.5rem', minWidth: '42rem', maxWidth: '42rem', textAlign: 'left' }}
    >
      <LoadingContainer linhas={16} loading={IsLoading} px={'2rem'} my={'1rem'}>
        <Flex flexDir={'column'} padding='0 1.5rem 1.25rem 1.5rem' gap={'.75rem'}>
          <Flex alignItems='center' flexDir={'column'} w={'full'} gap={'1rem'} mb={'1rem'}>
            <Avatar src={Model.avatar} w={'110px'} h={'110px'}/>
            <Flex flexDir={'column'} gap={'.5rem'} lineHeight={'1rem'} flex={'1'}>
              <Text>Nome: <strong>{Model.nome}</strong></Text>
              <Text fontSize={'.875rem'}>Data de ingresso: <strong>{Model.dataIngresso}</strong></Text>
            </Flex>
          </Flex>

          <Flex gap={'.75rem'}>
            <Flex flexDir={'column'} w={'full'}>
              <FormLabel color={'var(--Gray1)'} fontSize={'14px'} mb={'.25rem'}>Função (cargos e salários)</FormLabel>
              <FindUser
                lista={CargosESalarios.map(e => { return { id: e.id, nome: e.nomeCargo } })}
                onChoice={SelecionarCargoESalario}
                placeholder='Digite o nome da função (Obrigatório)'
                isNotUser
                leftIcon={<FaBriefcase size={'1.3rem'} />}
                isInvalid={CargoESalarioIsInvalid}
                selecionado={Model.cargoESalarioId}
                onBlur={() => {
                  if (PropInvalida(Model.cargoESalarioId)) {
                    setCargoESalarioIsInvalid(true)
                  } else {
                    setCargoESalarioIsInvalid(false)
                  }
                }}
              />
              {CargoESalarioIsInvalid &&
                <Flex mt={'.125rem'} alignItems={'center'} gap='.5rem'>
                  <Text color={'var(--Red)'} fontSize={'.813rem'}>Campo inválido!</Text>
                </Flex>
              }
            </Flex>

            <SelectCmp title='Nível hierárquico' value={Model.nivel} OnChange={(e) => setModel({ ...Model, nivel: e })} w={'100%'}>
              {!Model.cargoESalarioId && <option value={''}>Nenhum cargo selecionado</option>}
              {Model.cargoESalarioId && <>
                <option value={''}>Selecione um nível</option>
                {Object.entries(CargosESalarios.find(e => e.id === Model.cargoESalarioId)?.niveis ?? []).map(([key, nivel]) => {
                  return <option value={key?.replaceAll('_', ' ')}>{key.replaceAll('_', ' ')}</option>
                })}
              </>}
            </SelectCmp>
          </Flex>

          <Flex>
            <InputCmp InputLeftGroup='R$' min={0} value={Model.salario} label='Salário' OnChange={(e) => setModel({ ...Model, salario: Number(e) })} type={'number'}/>
          </Flex>

          <Flex justifyContent={'end'} mt={'.75rem'} gap={'.5rem'}>
            <ButtonCmp
              VarColor='c6'
              onClick={() => nav(-1)}
            >Cancelar</ButtonCmp>
            <ButtonCmp
              VarColor='Rosa'
              leftIcon={<FaEye/>}
              onClick={() => nav(`/Rh/VisualizarPerfil/${colaborador.id}`)}
            >Visualizar detalhes</ButtonCmp>
            <ButtonCmp
              VarColor='Green2'
              leftIcon={<FaSave/>}
              onClick={InternalOnUpdate}
            >Atualizar colaborador</ButtonCmp>
          </Flex>
        </Flex>
      </LoadingContainer>
    </ModalBase>
  )
}
